import { VoucherType } from "@tm/models"
import { Divider, Stack } from "@tm/components"
import TotalNumbers from "../../_shared/TotalNumbers"
import { TotalNumberType } from "../../../../../business"

type Props = {
    partsPositionCount?: number
    worksPositionCount?: number
}

export default function CostEstimationTotalNumbers({ partsPositionCount, worksPositionCount }: Props) {
    return (
        <Stack direction="row" spacing={1} divider={<Divider orientation="vertical" sx={{ height: "auto" }} />}>
            <TotalNumbers type={TotalNumberType.parts} totalNumber={partsPositionCount || 0} voucherType={VoucherType.CostEstimation} />
            <TotalNumbers type={TotalNumberType.works} totalNumber={worksPositionCount || 0} voucherType={VoucherType.CostEstimation} />
        </Stack>
    )
}
